import { useEffect } from 'react'
import { useLocation } from 'wouter'

/**
 * `/orders` sends the browser to `/lists`.
 *
 * Legacy mounts a bare `<Redirect to="/lists" />` at `/orders` — the old orders
 * screen was folded into the archive and the path was kept so bookmarks, the
 * kitchen tablet's home screen and every link staff pasted into chat keep
 * working. Owner decision 1 keeps it that way: `orders.tsx` is not ported.
 *
 * `replace` matters. Without it the redirect lands in the history stack and the
 * back button bounces off it forever.
 */
export function OrdersRedirect() {
  const [, navigate] = useLocation()

  useEffect(() => {
    navigate('/lists', { replace: true })
  }, [navigate])

  return null
}
